import { ACTION_COPY, ACTION_DELETE, ACTION_EDIT } from './model'

export const getActions = (state, handlers) => {
  const { actions, jobSeeker } = state
  const { handleCopy, handleDelete, handleEdit } = handlers

  return actions.map(action => {
    const mapTypeToOnClick = {
      [ACTION_EDIT]: () => handleEdit(jobSeeker),
      [ACTION_COPY]: () => handleCopy(jobSeeker),
      [ACTION_DELETE]: () => handleDelete(jobSeeker),
    }

    return {
      ...action,
      onClick: mapTypeToOnClick[action.type],
    }
  })
}
